import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApplicationFacadeService {
  public mainLayoutClicked$: EventEmitter<void> = new EventEmitter<void>()
}
